import React from "react"
import { actionKeys } from "@love-irish/i18n"
import { IconBook } from "@tabler/icons-react"
import LofiBrowserFrame from "@love-irish/core-lofi-browser-frame"
import BaseListItem from "../base"

export interface DictionaryListItemProps {
  item: Record<string, any>
  className?: string
  footer?: React.ReactNode
}

export const DictionaryListItem: React.FC<DictionaryListItemProps> = ({
  item,
  className,
  footer,
}) => (
  <BaseListItem
    item={item}
    className={className}
    footer={footer}
    typeIcon={IconBook}
    typeLabel="Dictionary"
    testId="dictionary-list-item"
    readMore={{ useI18n: true, actionKey: actionKeys.READ }}
    media={
      (item.imageUrl || item.thumbnailUrl) && (
        <LofiBrowserFrame className="m-0!">
          <div className="col-span-4">
            <a href={item.path}>
              <img
                src={item.thumbnailUrl || item.imageUrl}
                alt={item.name}
                className="max-w-[200px] @max-sm/list-item:max-w-[100px]"
              />
            </a>
          </div>
        </LofiBrowserFrame>
      )
    }
  />
)

export default DictionaryListItem
